export default __webpack_public_path__ + "static/media/baseline-close-24px.5c12600a.svg";